import { render } from "./Competition.vue?vue&type=template&id=54e56ec6&scoped=true&ts=true"
import script from "./Competition.vue?vue&type=script&lang=ts"
export * from "./Competition.vue?vue&type=script&lang=ts"

import "./Competition.vue?vue&type=style&index=0&id=54e56ec6&scoped=true&lang=scss"

import exportComponent from "/home/vsts/work/1/s/src/WebApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54e56ec6"]])

export default __exports__